var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResend(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6659FF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.712 22.592c-3.83 3.84-9.97 4.08-14.09.55-4.12-3.529-4.82-9.63-1.61-14 3.2-4.38 9.24-5.539 13.84-2.67l-.18-2.4c-.04-.549.37-1.029.92-1.069.55-.04 1.03.37 1.07.92l.34 4.63c.03.42-.2.8-.58.98-.01.01-.01.02-.02.01-.03.03-.06.04-.09.06L13.636 11.5c-.5.25-1.1.049-1.34-.44-.25-.5-.05-1.101.44-1.341l2.476-1.297c-2.32-1.649-5.35-2.02-8.04-.91-3.13 1.3-5.17 4.361-5.17 7.741 0 3.39 2.04 6.45 5.17 7.75 3.14 1.29 6.74.58 9.14-1.82.39-.38 1.01-.38 1.4.01.38.39.38 1.01 0 1.4z",
    transform: "translate(-487 -432) translate(487 429)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.a71378a5.svg";
export { ForwardRef as ReactComponent };